/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
var FolderOpenAltIcon = createIcon({
  name: 'FolderOpenAltIcon',
  height: 1024,
  width: 1243,
  svgPath: 'M1226.126 430.391c-11.538 5.641-24.709 8.466-39.511 8.466h-783.362c-121.691 0-172.409-79.465-172.409-79.465l-157.701-213.106 72.912 253.2c11.755 31.506 36.455 58.219 74.101 80.146 37.641 21.927 76.905 32.366 117.778 32.366h759.625v146.286c0 0-0.418 73.611-73.561 73.611-83.591 0-512 0-512 0l-51.826 81.083c0 0-30.041 64.734-94.041 64.734-73.143 0-243.257 0-292.571 0-83.591 0-73.143-73.143-73.143-73.143v-804.571h841.797c28.734 0 59.973 7.705 93.714 23.122 33.742 15.413 59.973 34.197 78.695 56.341l208.565 279.929c13.495 15.2 20.242 29.529 20.242 42.99 0 13.029-5.767 22.366-17.303 28.011v0z',
  yOffset: '64',
  xOffset: '',
  transform: 'rotate(180 0 512) scale(-1 1)'
});
export default FolderOpenAltIcon;